import * as React from "react";
import { inject, observer } from "mobx-react";
import ModelStore from "src/stores/ModelStore";
import "./ContactComponent.scss";
import InfoBox from "./InfoBox";


interface IState{
  view: string
}
interface IProps {
  modelStore?: ModelStore;
  craftForm?: HTMLFormElement;
}
@inject("modelStore")
@inject("craftForm")
@observer
export default class ContactComponent extends React.Component<IProps, IState > {  

  private ref:React.RefObject<HTMLDivElement>;

  constructor(props?: any, context?: any) {
    super(props, context);
    this.ref = React.createRef();
    this.state={view:"form"};

  }
  public render(){   
    
        return (
            <div className={"contact-form col-xs-12 col-md-6 col-lg-6 " + this.state.view}>
              <InfoBox/>
              <div className="from-view" ref={ this.ref } />
              <div className="thank-you">
                  <h2>Vielen Dank für Ihre Anfrage!</h2>
                  <p>Wir melden uns in Kürze.</p>
              </div>
              <div className="loader-wrap">
                  <div className="loader"/>
              </div>
            </div>
        );
        
  }
  public componentDidMount(){
   // coming
   this.ref!.current!.appendChild( this.props.craftForm as HTMLFormElement );
   this.fillForm();
   
  }

  private fillForm(){
    const modelStore =  this.props.modelStore as ModelStore;
    const form =  this.props.craftForm as HTMLFormElement; 

    (form.querySelector("#subject") as HTMLFormElement).value = modelStore.selectedProduct +" soll/en perfekt verpackt werden.";
    (form.querySelector("#form") as HTMLFormElement).value = modelStore.selectedModel!.title;
    (form.querySelector("#funktion") as HTMLFormElement).value = modelStore.selectedInlay ? modelStore.selectedInlay.title :"";
    (form.querySelector("#druck") as HTMLFormElement).value = modelStore.selectedPrintColors ? modelStore.selectedPrintColors :"";
    (form.querySelector("#veredelung") as HTMLFormElement).value = modelStore.selectedRefinements ? modelStore.selectedRefinements :"";

    (form.querySelector("#produkt") as HTMLFormElement).value = modelStore.selectedProduct ? modelStore.selectedProduct : ""; 
    (form.querySelector("#express") as HTMLFormElement).value = modelStore.selectedExpressMethod ? modelStore.selectedExpressMethod :"";

    form.addEventListener("submit",this.onSubmit.bind(this));
  }

  private validateForm(){
    const form =  this.props.craftForm as HTMLFormElement; 
    let err=0;
    const name = (form.querySelector("#from-name") as HTMLFormElement);
    const email = (form.querySelector("#from-email") as HTMLFormElement);
    const message = (form.querySelector("#message") as HTMLTextAreaElement);

    name.classList.remove("error");
    email.classList.remove("error");
    message.classList.remove("error");

    if(name.value===""){
      err++;
      name.classList.add("error");
    }
    if(email.value===""){
      err++;
      email.classList.add("error");
    }
    if(message.value===""){
      err++;
      message.classList.add("error");
    }

    return (err===0);

  }

  private onSubmit(evt: Event ){

    evt.preventDefault();

    if(!this.validateForm()){
      return;
    }
    this.setState({view:"sending"});

    const form = evt.currentTarget as HTMLFormElement;


   
    $.post({
      data: $(form).serialize(),
      dataType: 'json',
      success:(response) => {
        if (response.success) {
            // done !
            this.setState({view:"send"});
        } else {
            // response.error will be an object containing any validation errors that occurred, indexed by field name
            // e.g. response.error.fromName => ['From Name is required']
            alert('An error occurred. Please try again.');
        }
    },
    url: 'https://www.hoffmannundschelle.de/'
  });

  }
}


// WEBPACK FOOTER //
// ./src/components/ContactComponent.tsx